import styled from "styled-components";

export const StyledPopup = styled.div
`

margin-top:20px;
h1{
    text-align:center;
}
p{
    color:red;
    text-align:center;
}
.formdiv{
padding:20px 20px 20px 20px;
display:flex;
flex-direction:column;
width:360px;
height:auto;
background-color:#21262d;
color:white;
margin-right:auto;
margin-left:auto;
align-items:center;
border-radius:15px;

}
.formelements{
    margin:10px;
}

.formelements input{
    width:320px;
    border-radius:10px;
    height:40px;
    background-color:#121212;
    color:white;
}

.formelements button{
    width:320px;
    border-radius:10px;
    height:40px;
    background-color:#238636;
    border:none;
    color:white;
}
.newAccount{
    padding:20px 20px 20px 20px;
    margin-top:20px;
    width:360px;
    height:80x;
    margin-left:auto;
    margin-right:auto;
    text-align:center;
    border:1px solid grey;
    border-radius:10px;
}

button:hover{
    background-color:darkgreen;
    cursor:pointer;
}

`